import { AuthService } from '@aipb/auth';
import { baseUrl } from '@aipb/util/routing';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationAuthGuard implements CanActivate, CanLoad {
  // @ts-expect-error foo
  protected authenticated: boolean;
  // @ts-expect-error foo
  protected roles: string[];

  // @ts-expect-error foo
  private route: Route;
  // @ts-expect-error foo
  private activatedRouteSnapshot: ActivatedRouteSnapshot;

  constructor(private router: Router, private auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.auth.isLoggedIn$().pipe(
      mergeMap((isLoggedIn) => {
        this.authenticated = isLoggedIn;
        this.roles = this.auth.getUserRoles();
        this.activatedRouteSnapshot = route;

        return this.isAccessAllowed(route, state);
      })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: Route, segmentsUrlSegment: UrlSegment[]): boolean | Promise<boolean> | Observable<boolean> {
    return this.auth.isLoggedIn$().pipe(
      mergeMap((isLoggedIn) => {
        this.authenticated = isLoggedIn;
        this.roles = this.auth.getUserRoles();
        this.route = route;
        // @ts-expect-error foo
        return this.isAccessAllowed(null, null);
      })
    );
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // @ts-expect-error foo
    const requiredRoles: string[] = this.auth.appRequiredRoles[route.url[0].path];

    if (!requiredRoles || requiredRoles.length === 0) {
      return of(true);
    } else {
      if (!this.roles || this.roles.length === 0) {
        this.saveLoginRedirectUrl(state);
        this.router.navigate(['/not-authorized']);
        return of(false);
      }

      const hasRole = requiredRoles.every((role) => this.roles.indexOf(role) > -1);

      if (!hasRole) {
        this.saveLoginRedirectUrl(state);
        this.router.navigate(['/not-authorized']);
        return of(false);
      }

      return of(hasRole);
    }
  }

  private saveLoginRedirectUrl(state: RouterStateSnapshot): void {
    this.auth.updateLoginRedirectUrl(`${baseUrl()}${state.url}`);
  }
}
